// extracted by mini-css-extract-plugin
module.exports = {"icon-container":"NotificationsIcon_icon-container__m402k","icon":"NotificationsIcon_icon__opNZi","active-indicator":"NotificationsIcon_active-indicator__FBxsI"};